import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { CRow, CCol, CContainer, CSpinner } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cibFacebookF, cibInstagram, cibYoutube, cibTwitter } from '@coreui/icons'
import api from 'src/api/api'

const AppOrganismo = (props) => {
  const { sitio } = props
  const [cargando, setCargando] = useState(false)
  const [autoridades, setAutoridades] = useState([])

  const redesSome = () => {
    return (
      (autoridades?.facebook !== null && autoridades?.facebook !== undefined) ||
      (autoridades?.youtube !== null && autoridades?.youtube !== undefined) ||
      (autoridades?.twitter !== null && autoridades?.twitter !== undefined) ||
      (autoridades?.instagram !== null && autoridades?.instagram !== undefined)
    )
  }

  const visualizarDireccion = (direcciones) => {
    let _direcciones = direcciones?.split('* ').filter((elemento) => elemento !== '')
    return _direcciones !== undefined ? (
      _direcciones.map((direccion, index) => {
        return (
          <div style={{ fontSize: '1rem' }} key={`dir-${index}`}>
            {direccion}
          </div>
        )
      })
    ) : (
      <></>
    )
  }

  useEffect(() => {
    setCargando(true)
    if (sitio)
      api.sitiosAutoridades({ sitio: sitio }).then((response) => {
        if (response.data.success) {
          setAutoridades(response.data.data)
          setCargando(false)
        }
      })
  }, [sitio])

  return (
    <div className="pie-organismo w-100">
      <CContainer fluid className="container-er">
        {cargando ? (
          <CSpinner></CSpinner>
        ) : (
          <>
            <CRow>
              <CCol xs={12} sm={12} md={5}>
                <div style={{ fontSize: '1rem' }}>
                  <b>{autoridades?.descripcion}</b>
                </div>
              </CCol>
              <CCol xs={12} sm={12} md={4}>
                <CRow>{visualizarDireccion(autoridades?.direccion)}</CRow>
                <CRow>
                  <div style={{ fontSize: '1rem' }}>{autoridades?.telefono}</div>
                </CRow>
              </CCol>
              <CCol xs={12} sm={12} md={3}>
                {redesSome() && (
                  <CRow>
                    <CCol className="logos-redes">
                      {autoridades?.facebook !== null && autoridades?.facebook !== undefined && (
                        <a
                          href={autoridades?.facebook}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={'Facebook ' + autoridades.descripcion}
                        >
                          <CIcon
                            icon={cibFacebookF}
                            style={{ marginRight: '0.75rem', color: '#000' }}
                            height={15}
                          ></CIcon>
                        </a>
                      )}
                      {autoridades?.youtube !== null && autoridades?.youtube !== undefined && (
                        <a
                          href={autoridades?.youtube}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={'YouTube ' + autoridades.descripcion}
                        >
                          <CIcon
                            icon={cibYoutube}
                            style={{ marginRight: '0.75rem', color: '#000' }}
                            height={15}
                          ></CIcon>
                        </a>
                      )}
                      {autoridades?.twitter !== null && autoridades?.twitter !== undefined && (
                        <a
                          href={autoridades?.twitter}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={'Twitter ' + autoridades.descripcion}
                        >
                          <CIcon
                            icon={cibTwitter}
                            style={{ marginRight: '0.75rem', color: '#000' }}
                            height={15}
                          ></CIcon>
                        </a>
                      )}
                      {autoridades?.instagram !== null && autoridades?.instagram !== undefined && (
                        <a
                          href={autoridades?.instagram}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={'Instagram ' + autoridades.descripcion}
                        >
                          <CIcon icon={cibInstagram} style={{ color: '#000' }} height={15}></CIcon>
                        </a>
                      )}
                    </CCol>
                  </CRow>
                )}
                <CRow>
                  <CCol className="logos-redes">
                    <div>
                      <a style={{ fontSize: '1rem' }} href={'mailto:' + autoridades?.email}>
                        {autoridades.email}
                      </a>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </>
        )}
      </CContainer>
    </div>
  )
}

AppOrganismo.propTypes = {
  sitio: PropTypes.string.isRequired,
}

export default React.memo(AppOrganismo)
